import { render, staticRenderFns } from "./CustomerIbnaChange.vue?vue&type=template&id=6af3170a&scoped=true"
import script from "./CustomerIbnaChange.vue?vue&type=script&lang=js"
export * from "./CustomerIbnaChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af3170a",
  null
  
)

export default component.exports